module.exports = new __parcel__URL__("mid_ground_cloud_1-min.43d652b5.png").toString();